<main class="container">
  <div *ngIf="mId!=null" class="d-flex justify-content-end">
    <button mat-raised-button color="primary" class="m-2" (click)="printDoc()">Download Report</button>
  </div>
  <div class="m-4" style="display: none">
    <div class="card  ">
      <div class="row m-4">
        <mat-form-field appearance="outline" class="col-md-6 mt-2">
          <mat-label>Select Centre</mat-label>
          <mat-select [(ngModel)]="selectedCentre"  (selectionChange)="onCentreSelect($event)" >
            <mat-option *ngFor=" let c of (centres$|async) "
                        [value]="c">{{c.centreName}} </mat-option>
            <!--      <mat-option  value="All">All Centres</mat-option>-->
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="col-md-4 mt-2">
          <mat-label>Select a date range</mat-label>
          <mat-date-range-input [rangePicker]="picker">
            <input matStartDate [(ngModel)]="mStartDate" placeholder="Start date">
            <input matEndDate [(ngModel)]="mEndDate" placeholder="End date">
          </mat-date-range-input>
          <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-date-range-picker #picker></mat-date-range-picker>
        </mat-form-field>
        <button mat-mini-fab  (click)="searchData()"><mat-icon>search</mat-icon></button>
        <div class="col-md-6 mt-2 ">
          <label for="bigTextArea" class="fw-bold"> Problem Addressed in Counselling:</label>

          <textarea id="bigTextArea" class="form-control" rows="5" cols="50" [(ngModel)]="problemAddressed"></textarea>
        </div>
        <div class="col-md-6">
          <label for="counselling" class="fw-bold">Counselling:</label>

          <textarea id="counselling" class="form-control" rows="5" cols="50" [(ngModel)]="counselling"></textarea>
        </div>

        <div class="col-md-6">
          <label for="intervention" class="fw-bold">Intervention & Tools used:</label>
          <textarea id="intervention" class="form-control" rows="5" cols="50" [(ngModel)]="intervention">
  </textarea>
        </div>


        <div class="col-md-6">
          <label for="group" class="fw-bold">Group Counselling/ Activities:</label>
          <textarea id="group" class="form-control" rows="5" cols="50" [(ngModel)]="groupCounselling"></textarea>
        </div>

      </div>
      <div class="mx-4">
        <input type="file" accept="image/*" multiple (change)="onFilesSelected($event)"/>
      </div>

      <br>
      <div>
        <button mat-raised-button color="primary" (click)="openGallery()">Upload</button>
      </div>

      <div class="d-flex justify-content-center">
        <mat-form-field appearance="outline" class="mx-2 mt-2">
          <mat-label>Select Before Submit</mat-label>
          <mat-select (selectionChange)="getValues($event)"  >
            <mat-option value="draft">Draft</mat-option>
            <mat-option value="final">Final</mat-option>
          </mat-select>
        </mat-form-field>
        <button mat-raised-button color="primary" class="m-2" (click)="save()">Submit</button>
        <button mat-raised-button color="primary" class="m-2" (click)="printDoc()">Download Report</button>

      </div>


    </div>

  </div>

  <div class="bg-white p-2" #content id="previewCounselingReports">
    <section>
      <div style="display: flex; justify-content: flex-end;">
        <img style="height: 100px;" src="../../../../../assets/logo.png" alt="logo">
      </div>
    </section>

    <section class="text-dark">
      <div class="text-center">
        <h1 class="mb-0" style="text-align: center;"><strong>COUNSELLING IMPACT REPORT</strong></h1>
      </div>

      <div class="mx-8 mt-6">
        <p style="text-align: justify; text-justify: inter-word">{{ para1 }}</p>
        <p style="text-align: justify; text-justify: inter-word">{{ para2 }}</p>
      </div>

      <div class="mx-8 mt-6">
        <h3>Session Counts</h3>
        <ul>
          <li>Individual Sessions: {{ savedCounts?.individualSessions ?? getTotalSessions() }}</li>
          <li>Group Sessions: {{ savedCounts?.groupSessions ?? mAllGroupSessions.length }}</li>
          <li>Assessment Sessions: {{ savedCounts?.assessmentSessions ?? mAllAssessments.length }}</li>
          <li><b>Total Sessions: {{ getGrandTotalSessions() }}</b></li>
        </ul>
      </div>

      <div class="mx-8">
        <h4>Problem Addressed in Counselling:</h4>
        <p style="text-align: justify;text-justify: inter-word">{{ problemAddressed }}</p>
        <p style="text-align: justify;text-justify: inter-word">{{ counselling }}</p>

        <h4>Intervention & Tools used:</h4>
        <p style="text-align: justify;text-justify: inter-word">{{ intervention }}</p>

        <h4>Group Counselling/Activities:</h4>
        <p style="text-align: justify;text-justify: inter-word">{{ groupCounselling }}</p>

        <!--        <div class="image-grid img2">-->
        <!--          <div *ngFor="let image of selectedImages; let i = index" class="image-item">-->
        <!--            <img [src]="image" alt="Selected Image"/>-->
        <!--            <mat-icon *ngIf="showDelete" (click)="deleteImageFromArray(i, selectedImages)">delete</mat-icon>-->
        <!--          </div>-->
        <!--        </div>-->


        <!-- ══════════════ COUNSELLING PHOTOS ══════════════ -->
        <div class="col-md-12 marginleft preview-section"
             *ngIf="selectedImages.length || galleryImages.length">
          <div class="preview-section-header">
            <span class="preview-section-dot" style="background:#673ab7;"></span>
            <h3 class="preview-section-title">Counselling Session</h3>
            <div class="preview-section-line"></div>
          </div>
          <div class="preview-image-grid">
            <ng-container *ngFor="let image of selectedImages">
              <div class="preview-img-wrap">
                <img [src]="image" (click)="openImagePreview(image)" alt="Counselling" class="preview-img"/>
              </div>
            </ng-container>
            <ng-container *ngFor="let img of galleryImages">
              <div class="preview-img-wrap">
                <img [src]="img.url" [alt]="img.fileName" (click)="openImageInNewTab(img.url)" class="preview-img"/>
                <div class="preview-img-caption" *ngIf="img.centreName">
                  <small>{{ img.centreName }}</small>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- Image Preview Popup -->
        <div *ngIf="showPreview"
             style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.7); z-index: 9999; display: flex; align-items: center; justify-content: center;">
          <div style="position: relative;">
            <img [src]="previewImageUrl" alt="Preview" style="max-width: 90vw; max-height: 90vh; border: 4px solid #fff; border-radius: 8px;" />
            <button (click)="closeImagePreview()"
                    style="position: absolute; top: 8px; right: 8px; background: #fff; border: none; border-radius: 50%; width: 32px; height: 32px; font-size: 20px; cursor: pointer;">&times;</button>
          </div>
        </div>



        <p class="mt-5" *ngIf="showDischargeChart || showAdmissionChart">
          The Psychological Assessment data is analyzed to determine the level of coping ability and mental/emotional
          well-being.
          The following is the graphical representation of this data.
        </p>

        <div style="margin: 20px;">
          <h2 style="font-weight: bold; text-align: center;">{{ childDetails?.childName }}</h2>

          <div style="margin: 10px;" *ngIf="showAdmissionChart">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <app-apex-piechart
                *ngIf="showAdmissionChart && apexChartData1.length >= 1 && doughnutChartLabels.length >= 1"
                [chartLabels]="doughnutChartLabels"
                [chartTitle]="'Admission/Baseline Psychological Assessment'"
                [chartData]="apexChartData1">
              </app-apex-piechart>



            </div>
          </div>

          <div style="margin-top: 20px;" *ngIf="showDischargeChart">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <app-apex-piechart
                *ngIf="showDischargeChart && mDischargeChartData.length >= 1 && doughnutChartLabels.length >= 1"
                [chartLabels]="doughnutChartLabels"
                [chartTitle]="'Discharge/Final Baseline Assessments'"
                [chartData]="mDischargeChartData">
              </app-apex-piechart>
<!--              <div style="display: flex; justify-content: space-between; margin: 10px; gap:100px;">-->
<!--                &lt;!&ndash; Show green smiley if Yes percentage is greater than 1% &ndash;&gt;-->
<!--                <div style="flex: 1; cursor: pointer; text-align: center;" *ngIf="mDischargeChartData[1] > 1" cdkDragBoundary=".example-boundary" cdkDrag>-->
<!--                  <img src="../../../../../assets/images/smiley/greenSmiley.png" alt="green smiley" style="width: 1rem;">-->
<!--                </div>-->

<!--                &lt;!&ndash; Show neutral smiley if No percentage is greater than 1% &ndash;&gt;-->
<!--                <div style="flex: 1; cursor: pointer; text-align: center;" *ngIf="mDischargeChartData[2] > 1" cdkDragBoundary=".example-boundary" cdkDrag>-->
<!--                  <img src="../../../../../assets/images/smiley/neutral.png" alt="neutral smiley" style="width: 1rem;">-->
<!--                </div>-->

<!--                &lt;!&ndash; Show red emoji if Sometimes percentage is greater than 1% &ndash;&gt;-->
<!--                <div style="flex: 1; cursor: pointer; text-align: center;" *ngIf="mDischargeChartData[0] > 1" cdkDragBoundary=".example-boundary" cdkDrag>-->
<!--                  <img src="../../../../../assets/images/smiley/redEmoji.png" alt="sad smiley" style="width: 1rem;">-->
<!--                </div>-->
<!--              </div>-->
            </div>
          </div>

          <p *ngIf="showAdmissionChart || showDischargeChart" style="text-align: justify;text-justify: inter-word">
            <strong>Frequency of low coping:</strong> The number of circumstances beneficiaries reported to be stressed
            and unable to cope.
            <br>
            <strong>Frequency of moderate coping:</strong> The number of circumstances beneficiaries reported stress and
            inability to cope half of the time.
            <br>
            <strong>Frequency of high coping:</strong> The number of circumstances beneficiaries reported no stress and
            the ability to cope.
            As can be seen from the first graph, the ability to cope was reported low when the families came to the
            center.
          </p>

          <p style="text-align: justify; text-justify: inter-word">{{ endLine1 }}</p>
          <p style="text-align: justify; text-justify: inter-word">{{ endLine }}</p>
        </div>
      </div>
    </section>
  </div>


</main>
